var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Form",
        [
          _c(
            "FormItem",
            [
              _c("div", { staticClass: "legalPersonSign" }, [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.imgUrl,
                      expression: "!imgUrl"
                    }
                  ],
                  ref: "qrcode",
                  attrs: { id: "qrcode" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "confirm" },
                  [
                    _vm.imgUrl
                      ? [
                          _c("Icon", {
                            staticClass: "refresh",
                            attrs: {
                              type: "md-refresh",
                              disabled: _vm.disabled
                            },
                            on: { click: _vm.clearRefresh }
                          }),
                          _vm._v(" "),
                          _c("img", { attrs: { src: _vm.imgUrl, alt: "" } })
                        ]
                      : _c(
                          "Button",
                          {
                            staticClass: "btn-has",
                            attrs: { type: "primary", disabled: _vm.disabled },
                            on: { click: _vm.getRefresh }
                          },
                          [_vm._v("我已签名")]
                        )
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm.countryCode === "ES"
                ? _c("P", { staticClass: "text-tips" }, [
                    _vm._v(
                      "说明：法人签名主要应用于转代理+申报,请使用中文进行签名"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fileModelUrl
                ? _c("p", [
                    _c(
                      "a",
                      {
                        staticStyle: { color: "#16ade9" },
                        attrs: { href: _vm.fileModelUrl, target: "_black" }
                      },
                      [
                        _c("img", {
                          staticStyle: { position: "relative" },
                          attrs: {
                            src: require("@/assets/images/common/serch.png")
                          }
                        }),
                        _vm._v("\n          查看示例\n        ")
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-473ec9ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473ec9ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/LegalSigned/index.vue
// module id = null
// module chunks = 